module.exports = __webpack_public_path__ + "static/media/donbosco9.972cd472.jpg";